import { logger } from "@/lib/logger";
/**
 * Environment variable validation.
 *
 * Call validateEnv() at startup (main.tsx) to catch missing
 * configuration early rather than failing silently at runtime.
 */

const REQUIRED = ["VITE_SUPABASE_URL", "VITE_SUPABASE_PUBLISHABLE_KEY"] as const;

const OPTIONAL = [
  "VITE_POSTHOG_KEY",
  "VITE_LOGODEV_TOKEN",
  "VITE_SUPABASE_PROJECT_ID",
  "VITE_SUPABASE_ANON_KEY",
  "VITE_SENTRY_DSN",
  "VITE_SITE_URL",
] as const;

function requiredValue(key: string): string | undefined {
  const v = import.meta.env[key];
  return typeof v === "string" && v.trim() !== "" ? v : undefined;
}

export function validateEnv(): void {
  const missing = REQUIRED.filter((key) => !requiredValue(key));
  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variable(s): ${missing.join(", ")}. ` +
        "Copy .env.example to .env and add your project credentials."
    );
  }

  if (import.meta.env.DEV) {
    const missingOptional = OPTIONAL.filter((key) => !import.meta.env[key]);
    for (const key of missingOptional) {
      logger.warn(`[env] Optional variable not set: ${key}`);
    }
  }
}
